<template>
  <div class="works _width">

    <div class="_width">
      <!-- <mutong :flex_img="list"></mutong> -->

      <!-- <VueBarrel class="main"
                 ele="vue-barrel">
        <div v-for="item in brands"
             :key="item.brand"
             class="vue-barrel">
          <img :src="item.img"
               alt="">
        </div>
      </VueBarrel> -->

      <imgflexlayout></imgflexlayout>
    </div>
  </div>
</template>

<script>
import imgflexlayout from '@/components/community/img_flex/img_flex_layout.vue'
// import mutong from '@/components/community/img_flex/mutong.vue'


export default {
  data () {
    return {
      list: [{
        //   title: '这是标题1',
        //   tm: '2020-1-11',
        //   child: [{
        //     img: "https://res.cloudinary.com/css-tricks/image/upload/f_auto,q_auto/v1568814785/photostream-photos/DSC05466_kwlv0n.jpg"
        //   },
        //   {
        //     img: 'https://img0.baidu.com/it/u=1502637949,1944157994&fm=11&fmt=auto&gp=0.jpg'
        //   },
        //   {
        //     img: require('@/assets/image/banner/0.jpg'),
        //   }]
      }]
    }
  },

  created () {
    this.is_login();//是否登陆
    this.router_url = this.$route.fullPath;//当前地址url

  },
  computed: {},
  watch: {},
  created () {
    // let userId = this.$route.params && this.$route.params.id
    // let params = {
    //   userId: '83056ebdfce64888a97c2c9fe2529228',
    //   current: 1,
    //   size: 10,
    // }

  },
  mounted () { },

  methods: {

  },

  components: {
    imgflexlayout
  },

}
</script>

<style scoped>
@import "../../assets/css/Ucenter/Uworks.css";
</style>



// WEBPACK FOOTER //
// src/components/ucenter/Uworks.vue